import Modal from "../../../global/Modal";
import DeleteModal from "../../Common/Modals/components/DeleteModal";

export default function PaymentsDeleteModal(props) {
  const { openModal, handleCloseModal, handleDelete, isDeleting } = props;

  return (
    <Modal open={openModal} onClose={handleCloseModal} maxWidth="xs">
      <div className="flex flex-row items-center justify-center p-2">
        <DeleteModal
          additionalDetails={{
            deleteLabel: "Delete Payment",
            handleCancel: handleCloseModal,
            handleDelete,
            isDeleting,
          }}
        />
      </div>
    </Modal>
  );
}
